export default __webpack_public_path__ + "static/media/NeueHaasDisplay-Thin.82ddb55d.woff";